var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,17.01v-2.01H21v2.01H3Zm0,2.99v-1.03H21v1.03H3Zm0-7.02v-2.99H21v2.99H3Zm0-8.98H21v4.02H3V4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStroke);
export default __webpack_public_path__ + "static/1765206080/media/icon-stroke.851ca82d84feb865d1a7d05223ad31c7.svg";
export { ForwardRef as ReactComponent };